import { isEqual } from 'lodash'
import { useSelector } from 'react-redux'

import { useAbility } from '@/ability/ability-context'
import { FilterTemplateDeleteButton as Deletor } from '@/components/beneficiary/list/filter-template/FilterTemplateDeleteButton'
import { FilterTemplateEditor as Editor } from '@/components/beneficiary/list/filter-template/FilterTemplateEditor'
import { FilterTemplateSelectButton as Selector } from '@/components/beneficiary/list/filter-template/FilterTemplateSelectButton'
import { selectCurrentFilterTemplate } from '@/store/beneficiary-list-filters/selectors'
import { setCurrentFilterTemplate } from '@/store/beneficiary-list-filters/slice'
import { deleteFilterTemplate } from '@/store/beneficiary-list-filters/thunks'
import { CurrentFilterTemplate } from '@/store/beneficiary-list-filters/types'
import { defaultWidget } from '@/store/dashboard-widgets/slice'
import { useStoreDispatch, useStoreState } from '@/store/hooks'

export function FilterTemplateManagerWrapper() {
  const dispatch = useStoreDispatch()
  const ability = useAbility()

  const loading = useStoreState((state) => state.beneficiaryList.loading)

  const currentFilterTemplate = useSelector(selectCurrentFilterTemplate)

  const savedFilterTemplates = useStoreState(
    (state) => state.beneficiaryList.savedFilterTemplates,
  ).filter((ft) => ft.id !== defaultWidget.filterTemplate.id)

  const handleSelect = (filterTemplate: CurrentFilterTemplate) =>
    dispatch(setCurrentFilterTemplate(filterTemplate))

  const isSavedFilterTemplate = 'id' in currentFilterTemplate

  const handleDelete = () => {
    if (!isSavedFilterTemplate) return
    void dispatch(deleteFilterTemplate(currentFilterTemplate.id))
  }

  const hasChanges = isSavedFilterTemplate
    ? !isEqual(
        currentFilterTemplate,
        savedFilterTemplates.find((ft) => ft.id === currentFilterTemplate.id),
      )
    : true

  return (
    <div className="flex items-end gap-1">
      <Selector
        disabled={loading}
        onSelect={handleSelect}
        savedFilterTemplates={savedFilterTemplates}
        currentFilterTemplate={currentFilterTemplate}
      />

      {ability.can('accessRoute', 'admin') && isSavedFilterTemplate && (
        <div className="flex items-center">
          <Editor
            isNameUnique={(name, id) =>
              !savedFilterTemplates.some((f) => f.name == name && f.id !== id)
            }
            disabled={loading || !hasChanges}
            filterTemplate={currentFilterTemplate}
          />

          <Deletor disabled={loading} onDelete={handleDelete} />
        </div>
      )}
    </div>
  )
}
